import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { siteRenderingContextService } from './siteRenderingContextService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteRenderingContextService)
}
